import { useContext, useEffect, useRef } from 'react';
import { WindowRendererContext } from './Provider';

export const useWindowContext = () => {
    const { windowContext } = useContext(WindowRendererContext);
    return windowContext;
};
export const useSetWindowContext = () => {
    const { setWindowContext } = useContext(WindowRendererContext);
    return setWindowContext;
};

export const useCloseWindow = (close: () => void) => {

    const setContext = useSetWindowContext();
    const context = useWindowContext();
    const previousContext = useRef(context);

    useEffect(() => {
        previousContext.current = context;
    }, [context]);

    return () => {
        close();
        setContext(previousContext.current);
    };
};